var api = require("!../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??ref--4-oneOf-3-1!../../../../../../node_modules/sass-loader/dist/cjs.js??ref--4-oneOf-3-2!../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--4-oneOf-3-3!./OfferSearchCard.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};